module.exports = __webpack_public_path__ + "static/media/7.f8bc8e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/7.png
// module id = 1543
// module chunks = 0